<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de gastos</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/expense+c" (click)="createExpense()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncExpenses | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let expense">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/expense+u"
                    (click)="updateExpense(expense)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/expense" (click)="eliminate(expense)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="unity">
              <th mat-header-cell *matHeaderCellDef>Unidad</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.unity }}
              </td>
            </ng-container>

            <ng-container matColumnDef="package">
              <th mat-header-cell *matHeaderCellDef>Paquete</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.package }}
              </td>
            </ng-container>

            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef>Valor</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.value }}
              </td>
            </ng-container>

            <ng-container matColumnDef="qty">
              <th mat-header-cell *matHeaderCellDef>Cantidad</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.qty }}
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Total</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.total }}
              </td>
            </ng-container>

            <ng-container matColumnDef="term">
              <th mat-header-cell *matHeaderCellDef>Periodo</th>
              <td mat-cell *matCellDef="let expense">
                {{ expense.term }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchExpenses($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
